export const DOCUMENTS_API_ROOT = '/issues-tracking/v1/documents';

const path = suffix => `${DOCUMENTS_API_ROOT}${suffix}`;
export const getSettings = provider => provider.get(path('/settings'));
export const getDocument = (provider, id) => provider.get(path(`/${id}`));
export const createDocument = (provider, body) => provider.post(path(''), body);
export const updateDocument = (provider, id, body) =>
  provider.patch(path(`/${id}`), body);
export const deleteDocument = (provider, id) => provider.remove(path(`/${id}`));
export const createVariant = (provider, id, body) =>
  provider.post(path(`/${id}/variants`), body);
export const updateVariant = (provider, id, variantId, body) =>
  provider.patch(path(`/${id}/variants/${variantId}`), body);
export const deleteVariant = (provider, id, variantId) =>
  provider.remove(path(`/${id}/variants/${variantId}`));

export const requireData = response => {
  if (response?.ok) return response.data;
  const error = new Error(
    response?.errors
      ?.map(item => item.message)
      .filter(Boolean)
      .join(' ') || 'Request failed',
  );
  error.errors = response?.errors;
  error.statusCode = response?.statusCode;
  throw error;
};

export const metadataPayload = values => ({
  appVersion: values.appVersion,
  category: values.category,
  companyType: values.companyType || null,
  visibility: values.visibility,
  status: values.status,
  modules: values.modules || [],
  serviceAdministratorIds: values.serviceAdministratorIds || [],
  serviceProviderIds: values.serviceProviderIds || [],
});
export const metadataValues = document => ({
  ...metadataPayload(document),
  companyType: document.companyType || '',
  thumbnailFile: null,
});
export const variantPayload = ({ languageCode, title, description }) => ({
  languageCode,
  title: title.trim(),
  description: description || null,
});

export const pendingUploads = (provider, documentId, variantId, values) =>
  [
    ['pdfFile', 'PDF'],
    ['videoFile', 'VIDEO'],
    ['thumbnailFile', 'THUMBNAIL'],
  ]
    .filter(([field]) => values[field] instanceof File)
    .map(([field, kind]) => ({
      file: values[field],
      initiate: async signal =>
        requireData(
          await provider.post(
            path(`/${documentId}/uploads`),
            {
              kind,
              ...(kind !== 'THUMBNAIL' && { variantId }),
              fileName: values[field].name,
              fileSize: values[field].size,
            },
            { signal },
          ),
        ),
      confirm: async (uploadId, signal) =>
        requireData(
          await provider.post(
            path(`/${documentId}/uploads/${uploadId}/confirm`),
            undefined,
            { signal },
          ),
        ),
    }));
